const Features = () => {
  const features = [
    {
      icon: (
        <svg
          className="w-12 h-12 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: 'Self-Hosted',
      description:
        'Keep your data private and secure on your own infrastructure. Complete control over your time tracking data.'
    },
    {
      icon: (
        <svg
          className="w-12 h-12 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" />
          <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" />
        </svg>
      ),
      title: 'ActivityWatch Integration',
      description:
        'Seamlessly integrates with ActivityWatch for comprehensive activity monitoring and time tracking.'
    },
    {
      icon: (
        <svg
          className="w-12 h-12 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: 'Advanced Analytics',
      description:
        'Comprehensive reporting and analytics to help you understand your productivity patterns and optimize your workflow.'
    },
    {
      icon: (
        <svg
          className="w-12 h-12 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: 'Privacy Focused',
      description:
        'Your data stays on your servers. No cloud storage, no data collection, complete privacy and security.'
    },
    {
      icon: (
        <svg
          className="w-12 h-12 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: 'Customizable',
      description:
        'Highly configurable to match your workflow with custom categories, tags, and reporting options.'
    },
    {
      icon: (
        <svg
          className="w-12 h-12 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: 'Easy Deployment',
      description: 'Simple Docker deployment. Get up and running in minutes.'
    }
  ]

  return (
    <section className="py-20" style={{ backgroundColor: 'var(--bg-main)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className="text-4xl font-bold mb-4"
            style={{ color: 'var(--text-main)' }}
          >
            Why Choose TrakStr?
          </h2>
          <p
            className="text-xl max-w-2xl mx-auto"
            style={{ color: 'var(--text-main2)' }}
          >
            Built for individuals who value privacy and control over their data.
            Self-hostable time tracking with ActivityWatch integration.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="card card-feature stagger-item">
              <div className="mb-4" style={{ color: 'var(--link-main)' }}>
                {feature.icon}
              </div>
              <h3
                className="text-xl font-semibold mb-2"
                style={{ color: 'var(--text-main)' }}
              >
                {feature.title}
              </h3>
              <p style={{ color: 'var(--text-main2)' }}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features
